export default __webpack_public_path__ + "static/media/Group5378.85368015.svg";